export const contextMenuInjectionKey = 'ContextMenu'
